import { render, staticRenderFns } from "./widget-position.vue?vue&type=template&id=2536edc3&scoped=true"
import script from "./widget-position.vue?vue&type=script&lang=js"
export * from "./widget-position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2536edc3",
  null
  
)

export default component.exports